// Cache manager for template data to prevent loading issues
const CACHE_PREFIX = 'eyehill_';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export const cacheManager = {
  // Set data in cache with TTL
  set: (key, data) => {
    try {
      const cacheData = {
        data,
        timestamp: Date.now(),
        ttl: CACHE_TTL
      };
      localStorage.setItem(`${CACHE_PREFIX}${key}`, JSON.stringify(cacheData));
    } catch (error) {
      console.warn('Failed to cache data:', error);
      // Clear old cache if storage is full
      cacheManager.clearExpired();
    }
  },

  // Get data from cache if not expired
  get: (key) => {
    try {
      const cached = localStorage.getItem(`${CACHE_PREFIX}${key}`);
      if (!cached) return null;

      const cacheData = JSON.parse(cached);
      const now = Date.now();

      // Check if cache is expired
      if (now - cacheData.timestamp > cacheData.ttl) {
        localStorage.removeItem(`${CACHE_PREFIX}${key}`);
        return null;
      }

      return cacheData.data;
    } catch (error) {
      console.warn('Failed to get cached data:', error);
      return null;
    }
  },

  // Remove specific cache entry
  remove: (key) => {
    try {
      localStorage.removeItem(`${CACHE_PREFIX}${key}`);
    } catch (error) {
      console.warn('Failed to remove cache:', error);
    }
  },

  // Clear all expired cache entries
  clearExpired: () => {
    try {
      const now = Date.now();
      const keys = Object.keys(localStorage);
      
      keys.forEach(key => {
        if (key.startsWith(CACHE_PREFIX)) {
          try {
            const cacheData = JSON.parse(localStorage.getItem(key));
            if (now - cacheData.timestamp > cacheData.ttl) {
              localStorage.removeItem(key);
            }
          } catch (error) {
            // Remove corrupted cache entries
            localStorage.removeItem(key);
          }
        }
      });
    } catch (error) {
      console.warn('Failed to clear expired cache:', error);
    }
  },

  // Clear all cache
  clearAll: () => {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(CACHE_PREFIX)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.warn('Failed to clear cache:', error);
    }
  }
};

// Clear expired cache on load
cacheManager.clearExpired();